import React from 'react';
import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import { Tree } from 'primereact/tree';
import { InputText } from 'primereact/components/inputtext/InputText';
import { node } from 'prop-types';

const DialogType = Object.freeze({
  none: 0,
  delete: 1,
  rename: 2,
  newFolder: 3,
  switchLoc: 4,
});

export default class StandardFoldersEditDialogW extends React.Component {
  constructor(props) {
    super(props);
  }

  makeTextInput() {
    const { newNodeDataName, setNewNodeDataName } = this.props;
    return (
      <span className="p-float-label" style={{ marginTop: '2rem', marginBottom: '2rem' }}>
        <InputText
          autoFocus
          style={{ width: '20rem' }}
          id="dialogInpText"
          value={newNodeDataName || ''}
          onChange={(e) => setNewNodeDataName(e.target.value)}
        />
        <label htmlFor="dialogInpText">Objektname</label>
      </span>
    );
  }

  getDialogText() {
    const { currentDialogType, currentNode } = this.props;
    switch (currentDialogType) {
      case DialogType.delete:
        return currentNode.selectable
          ? `Möchten Sie die Standardtabelle '${currentNode.data.name}' wirklich löschen?`
          : (
            <div>
              <p><h3>{`Möchten Sie den Ordner '${currentNode.data.name}' wirklich löschen?`}</h3></p>
              <p>
                <h3>{`Achtung, dabei werden alle Standardtabellen im Ordner '${currentNode.data.name}' ebenfalls gelöscht.`}</h3>
              </p>
            </div>
          );
      case DialogType.rename:
        return <h3>{`Bitte geben Sie einen neuen Namen für den Ordner '${currentNode.data.name}' ein.`}</h3>;
      case DialogType.newFolder:
        return <h3>Bitte geben Sie einen Namen für den zu erstellenden Ordner ein.</h3>;
      case DialogType.switchLoc:
        return <h3>{`Bitte wählen Sie aus, wohin Sie '${currentNode.data.name}' verschieben wollen:`}</h3>;
      default:
        return 'Ungültiger Typ';
    }
  }

  getDialogHeader() {
    const { currentDialogType, currentNode } = this.props;

    switch (currentDialogType) {
      case DialogType.delete:
        return 'Löschen';
      case DialogType.rename:
        return 'Umbenennen';
      case DialogType.newFolder:
        return 'Unterordner erstellen';
      case DialogType.switchLoc:
        return currentNode.key.length > 3 ? 'Tabelle verschieben' : 'Ordner verschieben';
      default:
        return 'Ungültiger Typ';
    }
  }

  getDialogConfirmButtonText() {
    const { currentDialogType, currentNode } = this.props;
    switch (currentDialogType) {
      case DialogType.delete:
        return 'Löschen';
      case DialogType.rename:
        return 'Umbenennen';
      case DialogType.newFolder:
        return 'Erstellen';
      case DialogType.switchLoc:
        return currentNode.key.length > 3 ? 'Tabelle verschieben' : 'Ordner verschieben';
      default:
        return 'Ungültiger Typ';
    }
  }

  isButtonEnabled() {
    const { currentDialogType, newNodeDataName, selectedTreeNodeKey } = this.props;
    switch (currentDialogType) {
      case DialogType.delete:
        return true;
      case DialogType.rename:
        if (newNodeDataName && newNodeDataName.trim().length > 0) {
          return true;
        }
        return false;
      case DialogType.newFolder:
        if (newNodeDataName && newNodeDataName.trim().length > 0) {
          return true;
        }
        return false;
      case DialogType.switchLoc:
        let ret = false;
        if (selectedTreeNodeKey) {
          if (selectedTreeNodeKey.length === 5) ret = true;
        }
        return ret;
      default:
        return 'Ungültiger Typ';
    }
  }

  renderFooter() {
    const { onHide, confirmDialog } = this.props;

    return (
      <div>
        <Button
          id="continue"
          disabled={!this.isButtonEnabled()}
          label={this.getDialogConfirmButtonText()}
          icon="pi pi-check"
          onClick={() => confirmDialog()}
        />
        <Button
          id="cancel"
          label="Abbrechen"
          className="p-button-danger"
          icon="pi pi-times"
          onClick={() => onHide()}
        />
      </div>
    );
  }

  makeFileSelectionTree() {
    const { allNodes, selectedTreeNodeKey, currentNode } = this.props;
    const nodes = this.convertNodesForTree(JSON.parse(JSON.stringify(allNodes)), currentNode);
    return (
      <div>
        <div className="card">
          <Tree
            style={{ width: '35rem' }}
            value={nodes}
            selectionMode="single"
            selectionKeys={selectedTreeNodeKey}
            onSelectionChange={(e) => this.onTreeNodeSelectionChange(e.value)}
          />
        </div>
      </div>
    );
  }

  onTreeNodeSelectionChange(newFatherNodeKey) {
    console.log('onTreeNodeSelectionChange', newFatherNodeKey)
    const { setSelectedTreeNodeKey } = this.props;
    setSelectedTreeNodeKey(newFatherNodeKey);
  }

  convertNodesForTree(nodes) {
    const { currentNode } = this.props; // node to be handled
    // check all nodes
    nodes.forEach((node) => {
      node.label = node.data.name;
      node.selectable = true;
      // if (node.key.startsWith(currentNode.key)) {
      if (node.key.length !== 5) { // was 3 ##
        node.selectable = false;
      } else if (currentNode.key.substring(0, 5) === node.key) {
        node.selectable = false;
      }
      delete node.data;
      if (node.children) {
        this.convertNodesForTree(node.children);
      }
    });
    return nodes;
  }

  render() {
    const { onHide, currentDialogType } = this.props;

    return (
      <Dialog
        header={this.getDialogHeader(currentDialogType)}
        visible={!!currentDialogType}
        style={{ width: '42rem' }}
        footer={this.renderFooter()}
        onHide={() => onHide()}
        modal
      >
        <div style={{ height: '380px', overflowY: 'scroll' }}>
        <div>{this.getDialogText(currentDialogType)}</div>
        {currentDialogType === DialogType.switchLoc ? this.makeFileSelectionTree() : undefined}
        {(currentDialogType === DialogType.newFolder || currentDialogType === DialogType.rename)
          ? this.makeTextInput() : undefined}
        </div>
      </Dialog>
    );
  }
}
